import routerOptions0 from "/nuxtWeb/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.150.0_@parcel+watcher@2.6.0_@types+node@26.6.5_@vue+compile_k23zhie5oejfiywxjgweayetb4/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}